// @flow

import {getDisabledIdsList} from './getDisabledIdsList';

import type {TreeStructure} from '@pb/kit-component-tree-v2';

type UtilType = (data: TreeStructure, checkedIdsList: Array<string>, shouldSelect: boolean) => Array<string>;

const getAllMatchedIds: UtilType = (data, checkedIdsList, shouldSelect) => {
    return data.reduce((matchedIds, currentData) => {
        let children = [];
        const nextMatchedIds = [];
        if (currentData.children) {
            children = getAllMatchedIds(currentData.children, checkedIdsList, shouldSelect);
        }
        if (currentData.matchedSearch) {
            if (shouldSelect || children.length) {
                nextMatchedIds.push(currentData.id);
            }
        } else if (checkedIdsList.includes(currentData.id)) {
            nextMatchedIds.push(currentData.id);
        }
        return matchedIds.concat(nextMatchedIds, children);
    }, []);
};

export const toggleAllMatchedIds: UtilType = (data, checkedIdsList, shouldSelect) => {
    const disabledIds = getDisabledIdsList(data);
    const allMatchedIds = getAllMatchedIds(data, checkedIdsList, shouldSelect);

    return allMatchedIds.concat(disabledIds);
};
